






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { SchoolGroupPMAnalysis, SchoolGroupPMAnalysisData } from '@/models/school-group/school-group-pm-analysis';
@Component({
  name: 'GPmAnalysisChart',
})
export default class GPmAnalysisChart extends mixins(GPageBase) {
  @Prop() data: SchoolGroupPMAnalysis;
  chartOptions: any = {};
  chart: any;

  mounted() {
    // AIGROW2-664 クラスマネジメント・統計情報のグラフから生徒カルテへ遷移
    const refs = this.$refs as any;
    this.chart = refs.pmAnalysisChart.chart;
    this.chart.on('click', (params: any) => {
      const url = this.$router.resolve({
        name: 'student-record',
        params: { studentID: params.data.studentID.toString() }
      }).href
      window.open(url, '_blank')
    });

    this.chartOptions = {
      toolbox: {
        show: true,
        top: '50',
        right: 10,
        itemSize: 15,
        feature: {
          dataZoom: { show: true, title: { zoom: this.$t('ENLARGE').toString(), back: this.$t('UNDO').toString() } },
          restore: { show: true, title: this.$t('RESET').toString() },
        },
      },
      title: [
        {
          show: true,
          text: this.data.messageA,
          top: '5%',
          left: '10%',
        },
        {
          show: true,
          text: this.data.messageB,
          top: '5%',
          left: '55%',
        },
        {
          show: true,
          text: this.data.messageC,
          top: '90%',
          left: '60%',
        },
      ],
      grid: {
        show: false,
      },
      xAxis: {
        type: 'value',
        splitNumber: 2,
        max: 100,
        min: 0,
      },
      yAxis: {
        type: 'value',
        splitNumber: 2,
        max: 100,
        min: 0,
      },
      series: [
        {
          symbolSize: 10,
          data: this.data.analysisData.map((d: SchoolGroupPMAnalysisData) => {
            return {
              name: d.fullName,
              studentID: d.student.studentID,
              value: [d.xPos, d.yPos],
              label: {
                show: true,
                formatter: '{b}',
                color: '#000000',
                fontSize: 10,
                position: 'top',
                distance: 3,
              },
            };
          }),
          type: 'scatter',
        },
      ],
    };
  }
}
